import styles from './ModalCongratsRescue.module.css';

import Modal from 'react-responsive-modal';

import { Button } from '../../../../components/Button';
import { useCart } from '../../../../hooks/useCart';
import * as routes from '../../../../constants/Routes';
import iconReedem from '../../../../assets/images/iconReedem.png';

interface IModalCongratsRescue {
  modalCongratsIsOpen: boolean;
  clientNumberOfDaysToRedeem: number | string;
}

export function ModalCongratsRescue({
  modalCongratsIsOpen,
  clientNumberOfDaysToRedeem,
}: IModalCongratsRescue) {
  const { cart, clearCart } = useCart();

  const isAwardMoney = cart.some((item) => item.premiumType.value === 'BS2');
  const isAwardFisic = cart.some((item) => item.premiumType.value === 'Físico');
  const isAwardVoucher = cart.some(
    (item) => item.premiumType.value === 'digital'
  );

  const onHandleBackRedeemConfirmRescue = async () => {
    // console.log('mandar pra tela de redeem awards');
    sessionStorage.clear();
    clearCart();
    if (isAwardMoney) {
      return (window.location.href = routes.REDEEM_AWARDS);
    }
    if (isAwardFisic || isAwardVoucher) {
      return (window.location.href = routes.MY_RESCUES);
    }
  };

  return (
    <Modal
      open={modalCongratsIsOpen}
      onClose={onHandleBackRedeemConfirmRescue}
      center
    >
      <div>
        <div className="contents-modal">
          <div className="d-flex justify-content-center">
            <img
              className={styles.alert}
              src={iconReedem}
              alt="Cadastro confirmado"
            />
          </div>
          <h1 className="title-modal">Parabéns!</h1>
          {isAwardMoney && (
            <p className="subtitle-modal">
              Seu resgate foi feito com sucesso! Em {clientNumberOfDaysToRedeem}{' '}
              o dinheiro estará na sua conta.
            </p>
          )}
          {isAwardVoucher && isAwardFisic && (
            <p className="subtitle-modal">Seu resgate foi feito com sucesso!</p>
          )}
        </div>
        <div className={styles.contentBtn}>
          <Button
            style={{
              width: '100%',
              borderRadius: '0px',
              textTransform: 'uppercase',
              fontWeight: 'bold',
            }}
            text="Confirmar"
            type="button"
            color="primary"
            onClick={onHandleBackRedeemConfirmRescue}
          />
        </div>
      </div>
    </Modal>
  );
}
